/* eslint-disable angular/module-getter, angular/module-setter */

import { trackerServiceModule } from '../../services/tracker-service/tracker-service';

/**
 * @ngdoc directive
 * @name trackClick
 * @description
 * Tracks a click on an element
 *
 * @restrict A
 * @element ANY
 * @param {template} trackClick String to use as the tracked event name, not interpolated
 * @param {expression=} trackData Hash of key-values to store with the track
 * @param {string} track Allows using the same event name across multiple event types on one element
 *
 * @example
 * <example>
 * <a track-click="event.name" track-data="{ properties }"></a>
 * </example>
 */

/**
 * @ngdoc directive
 * @name trackChange
 * @description
 * Tracks a change event on an element
 *
 * @restrict A
 * @element ANY
 * @param {template} trackChange String to use as the tracked event name, not interpolated
 * @param {expression=} trackData Hash of key-values to store with the track
 * @param {string} track Allows using the same event name across multiple event types on one element
 *
 * @example
 * <example>
 * <input track-change="event.name" track-data="{ properties }">
 * </example>
 */

/**
 * @ngdoc directive
 * @name trackFocus
 * @description
 * Tracks focusing on an element
 *
 * @restrict A
 * @element ANY
 * @param {template} trackFocus String to use as the tracked event name, not interpolated
 * @param {expression=} trackData Hash of key-values to store with the track
 * @param {string} track Allows using the same event name across multiple event types on one element
 *
 * @example
 * <example>
 * <input track-focus="event.name" track-data="{ properties }">
 * </example>
 */

/**
 * @ngdoc directive
 * @name trackSubmit
 * @description
 * Tracks a form submission
 *
 * @restrict A
 * @element ANY
 * @param {template} trackSubmit String to use as the tracked event name, not interpolated
 * @param {expression=} trackData Hash of key-values to store with the track
 * @param {string} track Allows using the same event name across multiple event types on one element
 *
 * @example
 * <example>
 * <form track-submit="event.name" track-data="{ properties }"></form>
 * </example>
 */

export const trackComponentModule = angular.module('Q.components.track', [
  trackerServiceModule,
]);

['uiSref', 'ngClick'].forEach(function createLinkDirective(directiveName) {
  // setup the ui-sref directive to store the track-data on the tracker service so that it will know to
  // include those props on the next state change event
  trackComponentModule.directive(
    directiveName,
    /* @ngInject */ function (tracker) {
      return {
        restrict: 'A',
        link(scope, elem, attrs) {
          elem.bind('click', function () {
            tracker.srefProps = setProps(scope, elem, attrs, 'click');
          });
        },
      };
    },
  );
});

['click', 'change', 'focus', 'submit'].forEach(
  function createTrackDirective(event) {
    let directiveName = 'track' + event[0].toUpperCase() + event.slice(1);
    trackComponentModule.directive(
      directiveName,
      /* @ngInject */ function (tracker) {
        return {
          restrict: 'A',
          link(scope, elem, attrs) {
            elem.bind(event, function () {
              const eventName = attrs[directiveName];
              const properties = setProps(scope, elem, attrs, event);
              const options = attrs.trackOptions
                ? scope.$eval(attrs.trackOptions)
                : {};

              tracker.trackEvent(eventName, properties, options);
            });
          },
        };
      },
    );
  },
);

function setProps(scope, elem, attrs, event) {
  const properties = attrs.trackData ? scope.$eval(attrs.trackData) : {};
  properties.ui = properties.ui || {};
  properties.ui.event = event;
  properties.ui.text = elem.text().trim();
  properties.ui.class = elem.attr('class');
  properties.ui.id = elem.attr('id');
  properties.ui.tag = elem.prop('tagName');
  properties.ui.tooltip = elem.attr('tooltip');
  return properties;
}
